import { render, staticRenderFns } from "./CaregiverProfile.vue?vue&type=template&id=2f279dfc&scoped=true&"
import script from "./CaregiverProfile.vue?vue&type=script&lang=ts&"
export * from "./CaregiverProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CaregiverProfile.vue?vue&type=style&index=0&id=2f279dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f279dfc",
  null
  
)

export default component.exports